import React from "react";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";
import { PRIMARY } from "../../../utils/constansColors/index";

const CssTextField = styled(TextField)({
  width: "100%",
  "& .MuiOutlinedInput-root": {
    height: "42px", // Increased to 42px
    padding: "0 8px",
    borderRadius: "8px",
    backgroundColor: "#fff",
    fontSize: "13px",
    display: "flex",
    alignItems: "center",
    "& fieldset": {
      borderColor: "#e5e7eb",
    },
    "&:hover fieldset": {
      borderColor: "#f06524",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#f06524",
      borderWidth: "1px",
      boxShadow: "0 0 0 3px rgba(240, 101, 36, 0.1)",
    },
    "& input": {
      padding: "0 4px",
      height: "auto",
      fontSize: "13px",
    },
  },
  "& .MuiInputLabel-root": {
    fontSize: "13px",
    color: "#6b7280",
    zIndex: 5,
    transform: "translate(14px, 10px) scale(1)", // Adjusted for 42px
    pointerEvents: "none",
  },
  "& .MuiInputLabel-root.MuiInputLabel-shrink": {
    transform: "translate(14px, -9px) scale(0.75)",
    padding: "0 4px",
    backgroundColor: "#fff",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#f06524",
  },
});

const Input = ({ label, ...rest }) => {
  return <CssTextField id={label} label={label} {...rest} />;
};

export default Input;
